import accounting from "accounting";
import calculatePriceTable from "../helpers/calculatePriceTable";
import removeSection from "../helpers/removeSection";
import dotEnv from "dotenv";
import { applyDynamicWidth, confirmDeleteTitleSigner, handleConfirmModal,  handleIfPresent,  handleToggleAutoFillDates, handleToggleAutoPriceCalculation, pasteListingCoDataIntoSellingCo, pasteSellingCoDataIntoListingCo, setBuyingSideEmpty, setSellingSideEmpty, showDeleteConfirmToBroker, updateIndividualChangedField, handleOrGroupChange } from "../helperFunctions";
import { contractDataHandle } from "../../state/actions";
import { formatAndParse, formatPhoneNumber } from "../../../Common/utils/universalFuntions";
import {  noChangeCheckboxContractTypes } from "../../../Common/commondata/commonData";
import { calculateFinalNetSheetPrice, calculateMonthlyPrincipalAndInterest, calculateNetSheetAmtWyomingBuying, calculateNetSheetAmtWyomingSelling, calculateTheAnnualAmount, checkBrokerageFee, handleMortgageCalculation } from "../helpers/netsheetAmtCalculater";
import { addNewLoanComponent } from "../helpers/netSheetDynamicComponents";
import { Modal, message } from "antd";
import { amountToWordsHelper } from "../helpers/amountToWordsHelper";

dotEnv.config();

// const apiURL = process.env.REACT_APP_BASE_URL;
// const Buffer = require("buffer").Buffer;

let needsDbUpdate = false;
const timeouts = [];
let timeoutInput;
let globalSpecificData = {},
  priceInputFieldChange = false;
export const handleClearTimeouts = () => {
  if (timeouts.length > 0) {
    // console.log("canceling pending db updates");
    timeouts.forEach((to) => clearTimeout(to));
  }
};

export const handleCheckboxGroupUpdate = (selectedValue, cbGroup, specificData) => {
  document.querySelectorAll(`[data-cb-group="${cbGroup}"]`)?.forEach((element) => {
    if (element.value !== selectedValue) {
      if (element.checked) {
        element.checked = false;
        if (element.hasAttribute("data-enable-source")) {
          document.querySelectorAll(`[data-enable-target="${element.dataset?.enableSource}"]`).forEach((ele) => {
            if (ele.type !== "checkbox") {
              ele.value = "";
              specificData[ele.name] = "";
              if (ele.parentNode.classList.contains("grow-with-input") || ele.parentNode.classList.contains("grow-with-content")) {
                ele.parentNode.dataset.replicatedValue = "";
              }
            } else {
              // target is a checkbox
              ele.checked = false;
              specificData[ele.name] = "";
            }
          });
        }

        if (element.hasAttribute("data-linked-value")) {
          document.querySelectorAll(`[data-linked-value="${element.name}"][name="${element.dataset.linkedValue}"]`).forEach((ele) => {
            ele.value = "";
            specificData[ele.name] = "";
            if (ele.parentNode.classList.contains("grow-with-input") || ele.parentNode.classList.contains("grow-with-content")) {
              ele.parentNode.dataset.replicatedValue = "";
            }
          });
        }
      }
      // always clearing old checkbox value from specificData,
      // even if it wasn’t marked `checked`
      specificData[element.name] = "";
    } else {
      // setting values of selected one properly
      specificData[element.name] = [element.value];
    }
  });
};


export const handleClickEvent = ({event, currentUrlId, rootDocData, dispatch, handleInputSave, handleInput, handleBlur, contractAuthKey}) => {
  let pan1 = document.getElementById("pan1");
  if (event.target.hasAttribute("data-scroll-to")) {
    if (window.innerWidth <= 500) {
      dispatch(contractDataHandle.setDrawerPosition(false));
      pan1.style.animation = "sidebar-unload 400ms ease-out";
      setTimeout(() => {
        pan1.style.visibility = "hidden";
      }, 400);
    }
    const scrollTo = document.getElementById(event.target.dataset.scrollTo);
    scrollTo.scrollIntoView({ block: "center", inline: "start" });
    scrollTo.style.backgroundColor = "rgb(64, 255, 53)";
    setTimeout(() => (scrollTo.style.backgroundColor = ""), 3000);
  } else if (rootDocData?.contractType === 'TR' && event.currentTarget.hasAttribute('data-TR-expand-table')) {
    // Transaction report > Expand table logic
    // let row = event.currentTarget;
    let row = event.target.closest('tr');
    var listContainer = row?.querySelector('.list-container');
    var dropdownIcon = row?.querySelector('.dropdown-icon i');
    if (listContainer && dropdownIcon) {
      var isVisible = listContainer.style.display === 'block';
      listContainer.style.display = isVisible ? 'none' : 'block';
      dropdownIcon.classList.toggle('bi-caret-right-fill', isVisible);
      dropdownIcon.classList.toggle('bi-caret-down-fill', !isVisible);
      row.classList.toggle('expanded', !isVisible);
    }
  } else if (event.target.hasAttribute("data-co-buyer-broker-delete-icon") || event.target.hasAttribute("data-co-seller-broker-delete-icon") ) {
    showDeleteConfirmToBroker({event,  rootDocData, currentUrlId, handleInputSave})
  } else if (event.target.hasAttribute("data-add-loan") || event.target.parentElement.hasAttribute("data-add-loan")) {
    let valueObj = addNewLoanComponent({event});
    if (valueObj && Object.keys(valueObj).length) {
      let localData = JSON.parse(localStorage.getItem(currentUrlId)) ||{};
      localData = {
        ...localData,
        ...valueObj,
      };
      localStorage.setItem(currentUrlId, JSON.stringify(localData));
      handleInputSave(valueObj);
    }
  } else if (event.target.hasAttribute("data-select-box")){
        if (event.target.getAttribute("data-select-box") === "YesNoUnknown" && event.target.tagName === "INPUT" && !rootDocData?.signatureInfo?.length) {
          const inputElement = event.target;
          const parent = inputElement.parentElement;
          const name = inputElement.name;
          const value = inputElement.value;
      
          const select = document.createElement("select");
          select.name = name;
      
          select.style.cssText = `
            border: 0;
            border-bottom: 1px solid black !important;
            font-family: inherit;
            font-size: inherit;
            background-color: #f0f7fd;
            font-weight: bold;
            color: blue;
            margin-top: -15pt;
          `;
      
          const placeholderOption = document.createElement("option");
          placeholderOption.value = "";
          placeholderOption.text = "Select an option";
          placeholderOption.disabled = true;
          placeholderOption.selected = true;
          select.appendChild(placeholderOption);
      
          const options = [{label:"Yes", value:"yes"}, {label:"No", value:"no"}, {label:"Unknown", value:"unknown"}];
          options.forEach((option) => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.text = option.label;
            select.appendChild(opt);
          });
      
          select.addEventListener("change", function () {
            const selectedValue = this.value;
            const newInput = document.createElement("input");
            newInput.type = "text";
            newInput.size = "8";
            newInput.className = "clickable";
            newInput.name = name;
            newInput.value = selectedValue === "none" ? "" : selectedValue;
            newInput.setAttribute("data-select-box", "YesNoUnknown");
            newInput.readOnly = true;
          
            newInput.addEventListener("input", handleInput);
            newInput.addEventListener("blur", handleBlur);
            newInput.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                handleBlur(e);
              }
            });
          
            parent.replaceChild(newInput, this);
            newInput.focus();
            const inputEvent = new Event("input", { bubbles: true });
            newInput.dispatchEvent(inputEvent);
            const blurEvent = new Event("blur", { bubbles: true });
            newInput.dispatchEvent(blurEvent);
          });
      
          
          select.addEventListener("blur", function () {
            if (this.value === "") {
              const newInput = document.createElement("input");
              newInput.type = "text";
              newInput.size = "8";
              newInput.className = "clickable";
              newInput.name = name;
              newInput.value = value;
              newInput.setAttribute("data-select-box", "YesNoUnknown");
              newInput.readOnly = true;
      
              newInput.addEventListener("input", handleInput);
              newInput.addEventListener("blur", handleBlur);
              newInput.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                  handleBlur(e);
                }
              });
          
              parent.replaceChild(newInput, this);
              const inputEvent = new Event("input", { bubbles: true });
            newInput.dispatchEvent(inputEvent);
            const blurEvent = new Event("blur", { bubbles: true });
            newInput.dispatchEvent(blurEvent);
            }
          });
      
          parent.replaceChild(select, inputElement);
          select.focus();
        }
  } else if (event.target.hasAttribute("data-title-signer-delete")) {
    confirmDeleteTitleSigner({ event, rootDocData, currentUrlId, handleInputSave, dispatch, contractAuthKey });
  }
};

export const handleInputEvent = ({event, currentUrlId, handleInputSave, rootDocData, contractData}) => {
  if (event?.target?.classList?.contains('noAutoSave') || event?.target?.classList?.contains('relativeDateInput') || event?.target?.hasAttribute('data-no-auto-save')) {
    return;
  }
 // console.log("input fired for", event.target.name);
  if (event.target.type === "checkbox") {
    let specificData = {};
    if (event.target.dataset?.cbGroup && event.target.checked) {
      // console.log("has cb-group that needs updated");
      handleCheckboxGroupUpdate(event.target.value, event.target.dataset.cbGroup, specificData);
    }

    if (event?.target?.name === "DisableAutoPriceCaluations") {
      handleToggleAutoPriceCalculation(event, currentUrlId, handleInputSave, specificData);
    }
    if (event?.target?.name === "AutoFillDates") {
      handleToggleAutoFillDates(event, currentUrlId, handleInputSave, specificData, contractData);
      return;
    }
    const elements = Array.from(document.querySelectorAll(`[name="${event.target.name}"]:checked`));
    const values = elements.filter((e) => e.value !== `${e.name}__Other` && e.value !== "").map((e) => e.value);
    // console.log("elements", elements);
    // console.log("values", values);
    if (values?.length) {
      specificData[event.target.name] = values;
    } else {
      specificData[event.target.name] = "";
    }
   
    if (event.target.value === "Deleted" && event.target.checked === false) {
      specificData[event.target.name] = "";
      // specificData[`${event.target.name}__valueChanged`] = true;
    }

    // If no change checkbox is un-checked manually to remove date/Time
    if (event.target.value === "No Change" && event.target.checked === false) {
      // console.log("coming inside this one",event.target)
      if (noChangeCheckboxContractTypes?.includes(rootDocData?.contractType)) {
        // specificData[`${event.target.name}__valueChanged`] = true;
        specificData[event.target.name] = "";
        needsDbUpdate = true;
      }
    }

    // logic for None included checkboxes - if other than None is checked - remove None if checked before
    if (event.target.checked && !event.target.dataset?.linkedwithNone) {
      const elements = document.querySelectorAll(`[name="${event.target.name}"]:checked`);
      const noneElement = Array.from(elements).find((e) => e.getAttribute("data-linkedWith-none") === `${event.target.name}_None` && e.checked);
      if (noneElement) {
        noneElement.checked = false;
        if (specificData[event.target.name].includes(noneElement.value)) {
          // Remove "None" from the array
          specificData[event.target.name] = specificData[event.target.name].filter((value) => value !== noneElement.value);
        }
      }
    }

    // logic for None included checkboxes - if None is checked- remove others if checked before
    if (event.target.hasAttribute(`data-linkedWith-none`) && event.target.dataset?.linkedwithNone && event.target.checked) {
      specificData[event.target.name] = [event.target.value];
      const elements = Array.from(document.querySelectorAll(`[name="${event.target.name}"]:checked`));
      const otherElements = document.querySelectorAll(`[name="${event.target.name}__Other"]`);
      if (otherElements?.length > 0) {
        otherElements.forEach((element) => {
          element.value = "";
          specificData[element.name] = "";
        });
      }
      const elementsToBeUnchecked = elements.filter((e) => !e.hasAttribute("data-linkedWith-none") && e.value !== "").map((e) => e);
      elementsToBeUnchecked.forEach((el) => {
        el.checked = false;
      });
    }

    if (event.target.hasAttribute("data-linked-value") && !event.target.checked) {
      event.target.value = `${event.target.name}__Other`;
      // console.log("data-linked-value", event.target.value);
      document.querySelectorAll(`[data-linked-value="${event.target.name}"][name="${event.target.dataset.linkedValue}"]`).forEach((element) => {
        element.value = "";
        specificData[element.name] = "";
        if (element.parentNode.classList.contains("grow-with-input") || element.parentNode.classList.contains("grow-with-content")) {
          element.parentNode.dataset.replicatedValue = "";
        }
      });
    }

    if (event.target.dataset?.enableSource && !event.target.checked) {
      document.querySelectorAll(`[data-enable-target="${event.target.dataset?.enableSource}"]`).forEach((element) => {
        if (element.type === "checkbox") {
          element.checked = false;
        } else {
          element.value = "";
          if (element.parentNode.classList.contains("grow-with-input") || element.parentNode.classList.contains("grow-with-content")) {
            element.parentNode.dataset.replicatedValue = "";
          }
        }
        specificData[element.name] = "";
      });
    }

    if (event.target.hasAttribute("data-enable-target") && event.target.checked) {
      // checkbox needs another checkbox to be checked
      // console.log(event.target.name, " has a target that needs to be checked.");
      document.querySelectorAll(`[data-enable-source="${event.target.dataset.enableTarget}"]`).forEach((element) => {
        element.checked = true;
        element.dispatchEvent(new Event("input"));
      });
    }

    if (event.target.dataset?.removeTarget) {
      // console.log("has a remove target");
      const isSpecificData = handleConfirmModal({event, specificData, removeSection, handleInputSave, currentUrlId});
      if (isSpecificData) {
        specificData = {
          ...isSpecificData
        }
        needsDbUpdate = true;
      } else {
        needsDbUpdate = false;
        return;
      }
    }

    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};

    if (rootDocData?.contractType === 'TO' && event.target.name === 'DoubleSidedTransaction') {
      // after unchecking the DoubleSidedTransaction remove the copied side of the values on TO form
      if (event.target.checked === false) {
        if (localData && (localData["SellerAgents"]?.length === 1) && (localData["BuyerAgents"]?.length === 1) && (localData["SellerAgents"][0].personId === localData["BuyerAgents"][0].personId) && rootDocData?.titleCompanyDetails?.selectedBy) {
          let BuyerAgentData = localData['BuyerAgents'][0];
          let SellerAgentData = localData['SellerAgents'][0];
          let personId = BuyerAgentData?.personId || SellerAgentData?.personId;
          if (rootDocData?.titleCompanyDetails?.selectedBy === 'SELLER_AGENT') {
            // make selling company blank
            specificData = setBuyingSideEmpty({specificData, personId});
          } else if (rootDocData?.titleCompanyDetails?.selectedBy === 'BUYER_AGENT') {
            // make listing company blank
            specificData = setSellingSideEmpty({specificData, personId});
          }
          localData = {
            ...localData,
            ...specificData
          }
        }
      } else {
        if (localData && (localData["SellerAgents"]?.length === 1) && (localData["BuyerAgents"]?.length === 1) && (localData["SellerAgents"][0].personId === localData["BuyerAgents"][0].personId) && rootDocData?.titleCompanyDetails?.selectedBy) {
          if (rootDocData?.titleCompanyDetails?.selectedBy === 'SELLER_AGENT') {
            specificData = pasteListingCoDataIntoSellingCo({localData,specificData});
          }
          else if (rootDocData?.titleCompanyDetails?.selectedBy === 'BUYER_AGENT') {
            specificData = pasteSellingCoDataIntoListingCo({localData, specificData});
          }
        }
      }
    }

    localData = {
      ...localData,
      ...specificData,
    };
    localStorage.setItem(currentUrlId, JSON.stringify(localData));

    if (event?.detail?.noApiCall) {
      return;
    }
    handleInputSave(specificData);
    specificData = {};
    globalSpecificData = {};
  } else {
    let specificData = {};
    needsDbUpdate = true;
    if (event.target.hasAttribute("data-calculatepricetable")) {
      return;
    }
    // not a checkbox
    if (event.target.hasAttribute("data-additional-find-key") && event.target.hasAttribute("data-additional-find-value")) {
      // console.log("input fired for field with data-additional-find-key and data-additional-find-value");
      specificData["_toFind"] = {
        name: event.target.dataset.additionalFindKey,
        value: event.target.dataset.additionalFindValue,
      };
    }

    if (event.target.hasAttribute("data-linked-value")) {
      // console.log("element has linked value");
      const element = document.querySelector(`[name="${event.target.dataset.linkedValue}"][data-linked-value="${event.target.name}"]`);
      element.value = event.target.value;
      element.checked = true;
      element.dispatchEvent(
        new CustomEvent("input", {
          detail: {
            noApiCall: true,
          },
        })
      );
      if (event.target.type === "text" && event.target.value) {
        let localData = JSON.parse(localStorage.getItem(currentUrlId));
        specificData[event.target.getAttribute("data-linked-value")] = localData[event.target.getAttribute("data-linked-value")];
      }
    }
    specificData[event.target.name] = event.target.value;
    if (event.target.dataset?.enableTarget) {
      // console.log("added value connected with checkbox, enabling checkbox and clearing any in cbgroup");
      document.querySelectorAll(`[data-enable-source="${event.target.dataset?.enableTarget}"]`).forEach((element) => {
        element.checked = true;
        // console.log("element", element);
        specificData[element.name] = element.value;
        if (element.dataset?.cbGroup) {
          handleCheckboxGroupUpdate(element.value, element.dataset.cbGroup, specificData);
        }
      });
    }

    if (event.target.parentNode.classList.contains("grow-with-input") || event.target.parentNode.classList.contains("grow-with-content")) {
      event.target.parentNode.dataset.replicatedValue = event.target.value;
    }
   
    if(rootDocData?.contractType === 'TO'){
      specificData.SelectedBy = rootDocData?.openFor
    }
    globalSpecificData = {
      ...globalSpecificData,
      ...specificData,
    };
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    if (event.target.classList.contains("currency") && event.target.value !== localData[event.target.name]) {
      priceInputFieldChange = true;
    }

    if ( rootDocData?.contractType === 'TO' && document.getElementsByName('DoubleSidedTransaction')[0].checked && (event.target.value || event.target.value === "")) {
      if (localData && (localData["SellerAgents"]?.length === 1) && (localData["BuyerAgents"]?.length === 1) && (localData["SellerAgents"][0].personId === localData["BuyerAgents"][0].personId) && (rootDocData?.titleCompanyDetails?.selectedBy)) {
        let BuyerAgentData = localData['BuyerAgents'][0];
        let SellerAgentData = localData['SellerAgents'][0];
        let personId = BuyerAgentData?.personId || SellerAgentData?.personId;
        specificData = updateIndividualChangedField({event, personId, specificData});
      }
      globalSpecificData = {
        ...globalSpecificData,
        ...specificData,
      }
    }

    if (event.target.classList.contains("formatPhoneNumber")) {
      event.target.value = formatPhoneNumber(event.target.value);
      specificData[event.target.name] = event.target.value;
    }

    if (rootDocData?.contractType?.startsWith("WY")) {
      if (event?.target?.dataset?.timeInputField) {
        let datasetValue = event.target.dataset?.timeInputField;
        let timeFieldValue = event.target.value;
        if (timeFieldValue) {
          const [hourStr] = timeFieldValue.split(":");
          let hour = parseInt(hourStr, 10);
          // figure out AM/PM
          let meridian = "AM";
          if (hour === 0) {
            meridian = "AM"; // midnight → AM
            hour = 12;
          } else if (hour === 12) {
            meridian = "PM"; // noon
          } else if (hour > 12) {
            meridian = "PM";
            hour -= 12;
          }

          // GET ALL THE ASSOCIATED CHECKBOXES
          const checkboxes = document.querySelectorAll(`[name="${datasetValue}"][data-meridian-checkbox]`);
          // Uncheck all, then check the one that matches
          checkboxes.forEach(cb => {
            cb.checked = false;
            if (cb.dataset.meridianCheckbox === meridian) {
              cb.checked = true;
              specificData[cb.name] = cb.value;
            }
          });
          needsDbUpdate = true;
        }
      }
    }

    if (rootDocData?.contractType === "NET_SHEET" && event?.target?.name === "PurchasePrice" && (event.target.value !== localData["PurchasePrice"])) {
      if ([0, '0', "", "0.0", "0.00", undefined, null].includes(event.target.value)) {
        message.error("Please enter a valid Purchase Price, Purchase Price cannot be zero.");
        event.preventDefault();
        event.target.value = localData["PurchasePrice"];
        specificData[event.target.name] = localData["PurchasePrice"];
      }
    }

    // Either one group of element should be present
    if (event?.target?.hasAttribute("data-or-group")) {
      handleOrGroupChange({ event, specificData });
    }

    localData = {
      ...localData,
      ...specificData,
    };
    localStorage.setItem(currentUrlId, JSON.stringify(localData));
    if (event?.detail?.noApiCall) {
      return;
    }

    clearTimeout(timeoutInput);
    timeoutInput = setTimeout(() => {
      if (needsDbUpdate) {
        handleBlurEvent({event, currentUrlId, handleInputSave, contractData, rootDocData});
        specificData = {};
        globalSpecificData = {};
        needsDbUpdate = false;
      }
    }, 5000);
  }
};
function escapeRegex(s="") {
  return s?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function splitWithContext(normalizedValue, normalizedText, contextBefore = "", contextAfter = "") {
  try {
    const escaped = escapeRegex(normalizedText);
    const globalRe = new RegExp(escaped, "g");

    // If no context provided, behave like normal split
    if (!contextBefore && !contextAfter) {
      return normalizedValue.split(globalRe);
    }

    // Find the occurrence that has the required context
    let match;
    while ((match = globalRe.exec(normalizedValue)) !== null) {
      const idx = match.index;
      const beforeStart = Math.max(0, idx - contextBefore.length);
      const before = normalizedValue.slice(beforeStart, idx);
      const after = normalizedValue.slice(idx + normalizedText.length, idx + normalizedText.length + contextAfter.length);

      if (before === contextBefore && after === contextAfter) {
        // Found the contextual occurrence — split only at this index
        const firstPart = normalizedValue.slice(0, idx);
        const secondPart = normalizedValue.slice(idx + normalizedText.length);
        return [firstPart, secondPart];
      }
    }

    // No contextual match found — fallback to splitting on all occurrences
    return normalizedValue.split(globalRe);
  } catch (err) {}
}

export const handleBlurEvent = ({event, currentUrlId, handleInputSave, rootDocData, contractData}) => {
  if (event?.target?.classList?.contains('noAutoSave') || event?.target?.classList?.contains('relativeDateInput') || event?.target?.hasAttribute('data-no-auto-save')) {
    return;
  }
  // console.log("blur fired for", event.target.value);
  if (event.target.type === "checkbox") {
    return;
  }

  let checkBoxValues = {};
  let specificData = {};
  let localData = JSON.parse(localStorage.getItem(currentUrlId));
  if (event.target.hasAttribute("data-linked-value") && event.target.type === "text" && !event.target.value) {
    document.querySelectorAll(`[name="${event.target.dataset.linkedValue}"][data-linked-value="${event.target.name}"]`).forEach((element) => {
      element.checked = false;
      element.value = event.target.name;
      element.dispatchEvent(new Event("input"));
      needsDbUpdate = true; // it may be need outside of forEach
    });
    // needsDbUpdate = true;
  }

  if (event.target.hasAttribute("data-linked-value") && event.target.type === "text" && event.target.value) {
    let localData = JSON.parse(localStorage.getItem(currentUrlId));
    checkBoxValues[event.target.getAttribute("data-linked-value")] = localData[event.target.getAttribute("data-linked-value")];
    needsDbUpdate = true;
  }

  if (event.target.dataset?.enableTarget && !event.target.value) {
    document.querySelectorAll(`[data-enable-source="${event.target.dataset.enableTarget}"]`).forEach((element) => {
      element.checked = false;
      specificData[element.name] = null;
    });
    needsDbUpdate = true;
  }

  if (event.target.classList.contains("currency") && priceInputFieldChange) {
    if (event.target.value !== "") {
      let value = accounting.formatNumber(event.target.value, 2);
      specificData[event.target.name] = value;
      event.target.value = value;
      if (event.target.parentNode.classList.contains("grow-with-input") || event.target.parentNode.classList.contains("grow-with-content")) {
        event.target.parentNode.dataset.replicatedValue = value;
      }
    } else {
      specificData[event.target.name] = null;
    }

    if (event.target.hasAttribute("data-amount-words")) {
      amountToWordsHelper({ event, specificData });
    }
    needsDbUpdate = true;
    priceInputFieldChange = false;
  }

  if (event.target.hasAttribute("data-calculatepricetable") && event.target.value !== localData[event.target.name]) {
    if (rootDocData?.contractType === "WY_RLC") {
      const changed = event.target.name;
      const rows = [
        { total: "TotalRentPaid", rec: "RentRecieved", due: "RentDue" },
        { total: "TotalSecurityDeposit", rec: "SecurityDepositRecieved", due: "SecurityDepositDue" },
        { total: "TotalLastMonthRent", rec: "LastMonthRentRecieved", due: "LastMonthRentDue" },
        { total: "TotalPetFee", rec: "PetFeeRecieved", due: "PetFeeDue" },
        { total: "TotalPetDeposit", rec: "PetDepositRecieved", due: "PetDepositDue" },
      ];

      let grandTotal = 0,
        grandRec = 0,
        grandDue = 0;
      const table = {};

      rows.forEach(({ total, rec, due }) => {
        const recEl = document.getElementsByName(rec)[0];
        const dueEl = document.getElementsByName(due)[0];
        const totalEl = document.getElementsByName(total)[0];

        const recRaw = accounting.unformat(recEl.value) || 0;
        const dueRaw = accounting.unformat(dueEl.value) || 0;
        const totRaw = accounting.unformat(totalEl.value) || 0;

        let recVal = recRaw,
          dueVal = dueRaw,
          totVal = totRaw;

        if (changed === total) {
          // user edited total -> due = total − rec
          dueVal = totRaw - recRaw;
        } else {
          // user edited received -> due = total − rec
          dueVal = totRaw - recRaw;
        }

        totVal = totRaw; // total remains as-it is

        table[rec] = recVal;
        table[due] = dueVal;
        table[total] = totVal;

        grandRec += recVal;
        grandDue += dueVal;
        grandTotal += totVal;
      });

      // bottom total row
      table.Total = grandTotal;
      table.TotalRecieved = grandRec;
      table.TotalDue = grandDue;

      // formatting all
      const formatted = {};
      Object.entries(table).forEach(([k, v]) => {
        formatted[k] = accounting.formatNumber(v, 2);
      });

      Object.entries(formatted).forEach(([name, val]) => {
        specificData[name] = val === "0.00" ? "" : val;
        document.getElementsByName(name).forEach((el) => {
          el.value =  val === "0.00" ? "" : val;
          el.parentNode.dataset.replicatedValue =  val === "0.00" ? "" : val;
        });
      });

      // adjusting input width
      applyDynamicWidth(Object.keys(formatted), 65);

      needsDbUpdate = true;
    } else {
      const fieldsToGet = ["PurchasePrice", "EarnestMoney", "NewLoan", "AssumptionBalance", "PrivateFinancing", "SellerFinancing", "AdditionalPriceAmt1", "AdditionalPriceAmt2", "CashAtClosing"];
      const tableValues = {};
      // let maxWidth = 0;
      fieldsToGet.forEach((field) => {
        const elements = document.getElementsByName(field);
        if (elements.length) {
          const element = elements[0];
          const value = accounting.unformat(element.value);
          tableValues[field] = value;

          // // Calculateing the width of the input's value
          // const tempSpan = document.createElement("span");
          // tempSpan.style.position = "absolute";
          // tempSpan.style.visibility = "hidden";
          // tempSpan.style.whiteSpace = "nowrap";
          // tempSpan.textContent = element.value || "";
          // document.body.appendChild(tempSpan);
          // const computedWidth = tempSpan.offsetWidth + 2; // padding
          // maxWidth = Math.max(maxWidth, computedWidth);
          // document.body.removeChild(tempSpan);
        } else {
          tableValues[field] = 0;
        }
      });

      const updatedValues = calculatePriceTable(tableValues, "BLUR_EVENT", event?.target?.name);
      for (let key in updatedValues) {
        specificData[key] = updatedValues[key];
        const elements = document.getElementsByName(key);
        for (let i = 0; i < elements?.length; i++) {
          const element = elements[i];
          element.value = updatedValues[key];
          // element.style.width = `${maxWidth}px`;
          element.parentNode.dataset.replicatedValue = updatedValues[key];
        }
      }
      // adjusting widths on for all input fields, min 65px
      applyDynamicWidth(fieldsToGet, 65);
      needsDbUpdate = true;
    }
  }

  if (event.target.classList.contains("numberInput") || event.target.classList.contains("wholeNumberInput")) {
    const isDecimal = event.target.classList.contains("numberInput");

    if (event.target.value !== "") {
      let cleanedValue = isDecimal
        ? event.target.value
            .replace(/[^0-9.]/g, "") // keeping digits and dots
            .replace(/(\..*?)\..*/g, "$1") // allowing only the first dot
        : event.target.value.replace(/\D/g, ""); // digits only

      specificData[event.target.name] = cleanedValue;
      event.target.value = cleanedValue;

      if (event.target.parentNode.classList.contains("grow-with-input")) {
        event.target.parentNode.dataset.replicatedValue = cleanedValue;
      }
    } else {
      specificData[event.target.name] = null;
    }
  }

  // Net Sheet
  if (rootDocData?.contractType === 'NET_SHEET') {
    if (event.target.name === "PurchasePrice") {
      let td = { ...localData, ...specificData };
      let dataToUpdate = calculateFinalNetSheetPrice({ td, condition: "PURCHASE_PRICE_CHANGED" });
      specificData = { ...specificData, ...dataToUpdate };
    }
    if (rootDocData?.openForPropertyDoc && event.target.name !== "PurchasePrice" && (!localData[`PurchasePrice`] || [0, '0', "", null].includes(localData[`PurchasePrice`]))) {
      // Show an error message
      message.error("Please enter the Purchase Price first.");
      event.preventDefault();
      event.target.value = "";
      needsDbUpdate = false;
    }
    // If percent is changed, update the amount
    if (event.target.hasAttribute('data-percent-to-price')) {
      const percent = formatAndParse(event.target.value) / 100;
      const priceElement = document.querySelector(`[name="${event.target.dataset.percentToPrice}"]`);
      if (percent && priceElement && localData[`PurchasePrice`]) {
        priceElement.value = accounting.formatNumber((percent * formatAndParse(localData[`PurchasePrice`])), 2);
        specificData[priceElement.name] = accounting.formatNumber(priceElement.value, 2);
        specificData[event.target.name] = event.target.value;
        let td = {...localData, ...specificData};
        let otherAmounts = calculateFinalNetSheetPrice({td});
        specificData = { ...specificData, ...otherAmounts };
        needsDbUpdate = true;
      } else {
        if ([0, '0', "", null].includes(percent)) {
          specificData[event.target.name] = "";
          specificData[priceElement.name] = "";
          let td = {...localData, ...specificData};
          let otherAmounts = calculateFinalNetSheetPrice({td});
          specificData = { ...specificData, ...otherAmounts };
          needsDbUpdate = true;
        }
      }
    // If price is changed, update the percent
    } else if (event.target.hasAttribute('data-price-to-percent')) {
      const price = formatAndParse(event.target.value);
      const percentElement = document.querySelector(`[name="${event.target.dataset.priceToPercent}"]`);
      if (price && percentElement && localData[`PurchasePrice`]) {
        percentElement.value = accounting.formatNumber(((price / formatAndParse(localData[`PurchasePrice`])) * 100), 6);
        specificData[percentElement.name] = percentElement.value;
        specificData[event.target.name] = accounting.formatNumber(event.target.value, 2);
        let td = {...localData, ...specificData};
        let otherAmounts = calculateFinalNetSheetPrice({td});
        specificData = { ...specificData, ...otherAmounts };
        needsDbUpdate = true;
      } else {
        if ([0, '0', "", null].includes(price)) {
          specificData[event.target.name] = "";
          specificData[percentElement.name] = "";
          let td = {...localData, ...specificData};
          let otherAmounts = calculateFinalNetSheetPrice({td});
          specificData = { ...specificData, ...otherAmounts };
          needsDbUpdate = true;
        }
      }
    } else { // For Other currency fields that don't have percent/price conversion
      if (event.target && (event.target.value !== localData[event.target.name]) && event.target.classList.contains('currency')) {
        specificData[event.target.name] = accounting.formatNumber(event.target.value, 2);
        let td = { ...localData, ...specificData };
        let otherAmounts = calculateFinalNetSheetPrice({ td });
        specificData = { ...specificData, ...otherAmounts };
        needsDbUpdate = true;
      } else if (event.target && (event.target.value !== localData[event.target.name])) {
        specificData[event.target.name] = event.target.value;
        needsDbUpdate = true;
      }
    }
  }

  if (rootDocData?.contractType === "WY_NET_SHEET") {
    if (["PurchasePrice", "EstimatedCostOfSales", "NetProceedsFromSale"].includes(event.target.name)) {
      // DO NOTHING > NO NEED UNNECESSARY API CALLING
    } else if (["ListingSideBrokerageFee", "SellingSideBrokerageFee"].includes(event?.target?.name)) {
      specificData = checkBrokerageFee({ td: localData, source: "HANDLE_INPUT", event, specificData, needsDbUpdate });
    } else if ((contractData?.calculationFixedKeys?.group1).includes(event.target.name)) {
      let td = { ...localData, ...specificData };
      let { NetProceedsFromSale, EstimatedCostOfSales } = calculateNetSheetAmtWyomingSelling({ td, calculationFixedKeys: contractData?.calculationFixedKeys, source: "HANDLE_INPUT" });
      if (event?.target?.name === "BrokerageFee" && [0, "0", "0.00", "", null, undefined].includes(td["BrokerageFee"])) {
        specificData["SellingSideBrokerageFee"] = "0.00";
        specificData["ListingSideBrokerageFee"] = "0.00";
      }
      specificData = { ...specificData, NetProceedsFromSale, EstimatedCostOfSales };
    }
    needsDbUpdate = true;
  }

  if (rootDocData?.contractType === "WY_BGFE") {
    let name = event.target.name;
    const classList = event?.target?.classList || [];
    if (!(classList.contains("currency") || classList.contains("numberInput")) ||
      [
        "PurchasePrice",
        "TotalEstimatedClosingCosts",
        "FirstMortgagePrincipalAndInterest",
        "EstimatedMonthlyPayment",
        "SecondMortgagePrincipalAndInterest",
        "TotalEstimatedMonthlyPayment",
        "TotalEstimatedCashNeeded"
      ].includes(name)
    ) {
      // DO NOTHING > NO NEED UNNECESSARY API CALLING
    } else {
      let td = { ...localData, ...specificData };
      if (["PropertyTaxEscrowForTwoMonths", "AnnualPropertyTaxEscrow"].includes(name)) {
        let dataObj = calculateTheAnnualAmount({ event, td, source: "HANDLE_INPUT" });
        specificData = { ...specificData, ...dataObj };
        td = { ...localData, ...specificData };
      }
      if (["FirstMortgage", "FirstMortgageAnnualInterestRate", "FirstMortgageTermOfLoanInYears"].includes(name)) {
        td[name] = event?.target?.value;
        let FirstMortgagePrincipalAndInterest = handleMortgageCalculation({ prefix: "First", td, contractData, source: "HANDLE_INPUT" });
        specificData = { ...specificData, FirstMortgagePrincipalAndInterest };
        td = { ...localData, ...td, ...specificData };
      } else if (["SecondMortgage", "SecondMortgageAnnualInterestRate", "SecondMortgageTermOfLoanInYears"].includes(name)) {
        td[name] = event?.target?.value;
        let SecondMortgagePrincipalAndInterest = handleMortgageCalculation({ prefix: "Second", td, contractData, source: "HANDLE_INPUT" });
        specificData = { ...specificData, SecondMortgagePrincipalAndInterest };
        td = { ...localData, ...td, ...specificData };
      }
      td = { ...localData, ...td, ...specificData };

      // Recalculate the Net Sheet after mortgage calculation
      const dataToBeSaved = calculateNetSheetAmtWyomingBuying({
        td,
        calculationFixedKeys: contractData?.calculationFixedKeys,
        source: "HANDLE_INPUT",
      }) || {};
      specificData = { ...specificData, ...dataToBeSaved };
      needsDbUpdate = true;
    }
  }

  if (rootDocData?.contractType?.startsWith("WY")) {
    if (event?.target?.dataset?.timeInputField) {
      let datasetValue = event.target.dataset?.timeInputField;
      let timeFieldValue = event.target.value;
      if (timeFieldValue) {
        const [hourStr] = timeFieldValue.split(":");
        let hour = parseInt(hourStr, 10);
        // figure out AM/PM
        let meridian = "AM";
        if (hour === 0) {
          meridian = "AM"; // midnight → AM
          hour = 12;
        } else if (hour === 12) {
          meridian = "PM"; // noon
        } else if (hour > 12) {
          meridian = "PM";
          hour -= 12;
        }

        // GET ALL THE ASSOCIATED CHECKBOXES
        const checkboxes = document.querySelectorAll(`[name="${datasetValue}"][data-meridian-checkbox]`);
        // Uncheck all, then check the one that matches
        checkboxes.forEach(cb => {
          cb.checked = false;
          if (cb.dataset.meridianCheckbox === meridian) {
            cb.checked = true;
            specificData[cb.name] = cb.value;
          }
        });
        needsDbUpdate = true;
      }
    }
  }

  // Either one group of element should be present
  if (event?.target?.hasAttribute("data-or-group")) {
    handleOrGroupChange({ event, specificData });
  }

  if (["AnnualIntRatePercent", "LoanAmortizationPeriod", "PrincipalLoanAmount"].includes(event.target.id)) {
    let LoanAmortizationPeriodElement = document.getElementById("LoanAmortizationPeriod");
    let AnnualIntRatePercentElement = document.getElementById("AnnualIntRatePercent");
    let PrincipalLoanAmountElement = document.getElementById("PrincipalLoanAmount");
    let MonthlyPrincipalAndInterestAmtElement = document.getElementById("MonthlyPrincipalAndInterestAmt");

    let LoanAmortizationPeriod = LoanAmortizationPeriodElement?.value || "0.00"; // Yearly n = numberOfPaymentsToMake , LoanAmortizationPeriod
    let AnnualIntRatePercent = AnnualIntRatePercentElement?.value || "0.00"; // Yearly i = AnnualIntRatePercent
    let PrincipalLoanAmount = PrincipalLoanAmountElement?.value || "0.00"; // P = LoanAmount = Principal

    let MonthlyPrincipalAndInterestAmt = null;

    const invalidValues = ["0", 0, "0.00", "", null, undefined];
    if (event.target.id === "AnnualIntRatePercent" && !invalidValues.includes(LoanAmortizationPeriod) && !invalidValues.includes(PrincipalLoanAmount)) {
      MonthlyPrincipalAndInterestAmt = calculateMonthlyPrincipalAndInterest({ numberOfPaymentsToMake: LoanAmortizationPeriod, AnnualIntRatePercent: event.target.value, Principal: PrincipalLoanAmount });

    } else if (event.target.id === "LoanAmortizationPeriod" && !invalidValues.includes(AnnualIntRatePercent) && !invalidValues.includes(PrincipalLoanAmount)) {
      MonthlyPrincipalAndInterestAmt = calculateMonthlyPrincipalAndInterest({ numberOfPaymentsToMake: event.target.value, AnnualIntRatePercent, Principal: PrincipalLoanAmount });

    } else if (event.target.id === "PrincipalLoanAmount" && !invalidValues.includes(AnnualIntRatePercent) && !invalidValues.includes(LoanAmortizationPeriod)) {
      MonthlyPrincipalAndInterestAmt = calculateMonthlyPrincipalAndInterest({ numberOfPaymentsToMake: LoanAmortizationPeriod, AnnualIntRatePercent, Principal: event.target.value });
    }

    if (MonthlyPrincipalAndInterestAmt && MonthlyPrincipalAndInterestAmtElement?.name) {
      specificData = { ...specificData, [MonthlyPrincipalAndInterestAmtElement?.name]: MonthlyPrincipalAndInterestAmt };
      localData = {
        ...localData,
        ...specificData,
      };
      Modal.info({
        title: <div>Please note that updating this field will calculate/re-calculate the <strong>Monthly payments of principal and interest</strong></div>,
        onOk() {},
      });
    }
  }

  globalSpecificData = {
    ...globalSpecificData,
    ...specificData,
    ...checkBoxValues,
  };

  localData = {
    ...localData,
    ...globalSpecificData,
  };

  handleIfPresent({signatureSequence: contractData?.signatureSequence, localData});
  localStorage.setItem(currentUrlId, JSON.stringify(localData));

  if (needsDbUpdate) {
    handleClearTimeouts();
    // specificData[event?.target?.name] = event?.target?.value;
    handleInputSave({ ...globalSpecificData });
    specificData = {};
    globalSpecificData = {};
    needsDbUpdate = false;
  }
};

export const applyStrikeThroughs = (doc, strikeThroughSections) => {
  if (!strikeThroughSections?.length) return doc;

  const normalize = (str) =>
    str ? str.replace(/\u00A0/g, " ").replace(/\s+/g, " ") : "";

  strikeThroughSections?.forEach(({ text, path, contextBefore, contextAfter }) => {
    if (!text) return;

    const normalizedText = normalize(text);
    let targetEl = doc.querySelector(path?.split(" > ").join(" "));

    // Robust fallback for cases where input/checkbox breaks the path
    if (!targetEl) {
      const safePath = path
        ?.split(" > ")
        .filter((seg) => !/input|textarea|checkbox/i.test(seg))
        .join(" > ");
      targetEl = doc.querySelector(safePath);

      if (!targetEl && safePath) {
        const parentSelector = safePath.split(" > ").slice(0, -1).join(" > ");
        const parent = parentSelector ? doc.querySelector(parentSelector) : null;
        if (parent) {
          const nearbyTextNode = [...parent.childNodes].find(
            (n) =>
              n.nodeType === 3 &&
              n.textContent &&
              normalize(n.textContent).includes(normalizedText)
          );
          if (nearbyTextNode) targetEl = nearbyTextNode.parentElement;
        }
      }

      if (!targetEl) {
        const allTextNodes = [...doc.querySelectorAll("body *")]
          .flatMap((el) =>
            [...el.childNodes].filter(
              (n) => n.nodeType === 3 && normalize(n.textContent).includes(normalizedText)
            )
          );
        if (allTextNodes.length === 1) {
          targetEl = allTextNodes[0]?.parentElement;
        }
      }
    }

    if (targetEl) {
      if (targetEl?.tagName === "INPUT" || targetEl?.tagName === "TEXTAREA" || targetEl?.isContentEditable) {
        targetEl.style.textDecoration = "line-through";
        targetEl.style.color = "#555";
        return;
      }
    }

    if (targetEl) {
      const hasFormSibling =
        (targetEl?.previousSibling &&
          targetEl?.previousSibling.nodeType === 1 &&
          ["INPUT", "TEXTAREA"].includes(targetEl?.previousSibling?.tagName)) ||
        (targetEl?.nextSibling &&
          targetEl?.nextSibling.nodeType === 1 &&
          ["INPUT", "TEXTAREA"].includes(targetEl?.nextSibling?.tagName));

      if (hasFormSibling) {
        const textNode = [...targetEl.childNodes].find(
          (n) => n.nodeType === 3 && normalize(n.textContent).includes(normalizedText)
        );
        if (textNode) {
          const span = document.createElement("span");
          span.dataset.strikeThroughSection = "true";
          span.style.textDecoration = "line-through";
          span.style.color = "#555";
          span.style.display = "inline";
          span.style.whiteSpace = "pre-wrap";

          // create a display version that preserves NBSP but normalizes other whitespace
          const displayText = (text || "").replace(/\u00A0/g, "\u00A0").replace(/[^\S\u00A0]+/g, " ");
          span.appendChild(document.createTextNode(displayText));

          // Attempt original split by the stored text. If that fails (likely due to NBSP mismatch),
          // fallback to regex splitting on normalized text.
          let parts = textNode?.textContent.split(text);
          if (!parts || parts?.length === 1) {
            const regex = new RegExp(normalizedText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
            parts = textNode.textContent.split(regex);
          }

          const frag = document.createDocumentFragment();
          if (parts[0]) frag.appendChild(document.createTextNode(parts[0]));
          frag.appendChild(span);
          if (parts[1]) frag.appendChild(document.createTextNode(parts[1]));
          textNode.parentNode.replaceChild(frag, textNode);
          return;
        }
      }
    }

    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false);
    let node;

    while ((node = walker.nextNode())) {
      const value = node.nodeValue;
      const normalizedValue = normalize(value);

      const beforeMatch = contextBefore ? normalizedValue?.includes(normalize(contextBefore)) : true;
      const afterMatch = contextAfter ? normalizedValue?.includes(normalize(contextAfter)) : true;

      if (!normalizedValue?.includes(normalizedText) || !beforeMatch || !afterMatch) continue;

      const parent = node.parentNode;

      if (
        parent?.dataset?.strikeThroughSection ||
        (parent.nodeName === "SPAN" && parent.style.textDecoration === "line-through")
      ) {
        continue;
      }

      const span = document.createElement("span");
      span.dataset.strikeThroughSection = "true";
      span.style.textDecoration = "line-through";
      span.style.color = "#555";
      span.style.display = "inline";
      span.style.whiteSpace = "pre-wrap";

      const displayText = (text || "").replace(/\u00A0/g, "\u00A0").replace(/[^\S\u00A0]+/g, " ");
      span.appendChild(document.createTextNode(displayText));

     const parts = splitWithContext(normalizedValue, normalizedText, contextBefore, contextAfter);
    // console.log({ normalizedValue, normalizedText, contextBefore, contextAfter, parts });
    

      const frag = document.createDocumentFragment();
      if (parts?.[0]) frag.appendChild(document.createTextNode(parts[0]));
      frag.appendChild(span);
      if (parts?.[1]) frag.appendChild(document.createTextNode(parts[1]));

      parent.replaceChild(frag, node);
      break;
    }
  });

  return doc;
};

export const applyHighlights = (doc, highlightSections) => {
  if (!highlightSections?.length) return doc;

  const normalize = (str) =>
    str ? str.replace(/\u00A0/g, " ").replace(/\s+/g, " ") : "";

  highlightSections?.forEach(({ text, path, contextBefore, contextAfter }) => {
    if (!text) return;

    const normalizedText = normalize(text);
    let targetEl = doc.querySelector(path?.split(" > ")?.join(" "));

    if (!targetEl) {
      const safePath = path
        ?.split(" > ")
        .filter((seg) => !/input|textarea|checkbox/i.test(seg))
        .join(" > ");
      targetEl = doc.querySelector(safePath);

      if (!targetEl && safePath) {
        const parentSelector = safePath.split(" > ").slice(0, -1).join(" > ");
        const parent = parentSelector ? doc.querySelector(parentSelector) : null;
        if (parent) {
          const nearbyTextNode = [...parent.childNodes].find(
            (n) =>
              n.nodeType === 3 &&
              n.textContent &&
              normalize(n.textContent).includes(normalizedText)
          );
          if (nearbyTextNode) targetEl = nearbyTextNode.parentElement;
        }
      }

      if (!targetEl) {
        const allTextNodes = [...doc.querySelectorAll("body *")]
          .flatMap((el) =>
            [...el.childNodes].filter(
              (n) => n.nodeType === 3 && normalize(n.textContent).includes(normalizedText)
            )
          );
        if (allTextNodes.length === 1) {
          targetEl = allTextNodes[0].parentElement;
        }
      }
    }

    // For inputs/textareas — unchanged
    if (targetEl) {
      if (targetEl?.tagName === "INPUT" || targetEl?.tagName === "TEXTAREA" || targetEl?.isContentEditable) {
        targetEl.style.backgroundColor = "yellow";
        targetEl.style.color = "#000";
        return;
      }
    }

    // If targetEl has input/checkbox siblings
    if (targetEl) {
      const hasFormSibling =
        (targetEl?.previousSibling &&
          targetEl?.previousSibling?.nodeType === 1 &&
          ["INPUT", "TEXTAREA"].includes(targetEl?.previousSibling?.tagName)) ||
        (targetEl?.nextSibling &&
          targetEl?.nextSibling?.nodeType === 1 &&
          ["INPUT", "TEXTAREA"].includes(targetEl?.nextSibling?.tagName));

      if (hasFormSibling) {
        const textNode = [...targetEl.childNodes].find(
          (n) => n.nodeType === 3 && normalize(n.textContent).includes(normalizedText)
        );
        if (textNode) {
          const span = document.createElement("span");
          span.dataset.highlightSection = "true";
          span.style.backgroundColor = "yellow";
          span.style.color = "#000";
          span.style.display = "inline";
          span.style.whiteSpace = "pre-wrap";

          const displayText = (text || "").replace(/\u00A0/g, "\u00A0").replace(/[^\S\u00A0]+/g, " ");
          span.appendChild(document.createTextNode(displayText));

          let parts = textNode?.textContent?.split(text);
          if (!parts || parts.length === 1) {
            const regex = new RegExp(normalizedText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
            parts = textNode.textContent.split(regex);
          }

          const frag = document.createDocumentFragment();
          if (parts[0]) frag?.appendChild(document.createTextNode(parts[0]));
          frag?.appendChild(span);
          if (parts[1]) frag?.appendChild(document.createTextNode(parts[1]));
          textNode?.parentNode?.replaceChild(frag, textNode);
          return;
        }
      }
    }

    // Original walker logic
    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false);
    let node;

    while ((node = walker.nextNode())) {
      const value = node.nodeValue;
      const normalizedValue = normalize(value);

      const beforeMatch = contextBefore ? normalizedValue?.includes(normalize(contextBefore)) : true;
      const afterMatch = contextAfter ? normalizedValue?.includes(normalize(contextAfter)) : true;

      if (!normalizedValue?.includes(normalizedText) || !beforeMatch || !afterMatch) continue;

      const parent = node.parentNode;

      if (
        parent?.dataset?.highlightSection ||
        (parent.nodeName === "SPAN" && parent.style.backgroundColor === "yellow")
      ) {
        continue;
      }

      const span = document.createElement("span");
      span.dataset.highlightSection = "true";
      span.style.backgroundColor = "yellow";
      span.style.color = "#000";
      span.style.display = "inline";
      span.style.whiteSpace = "pre-wrap";

      const displayText = (text || "").replace(/\u00A0/g, "\u00A0").replace(/[^\S\u00A0]+/g, " ");
      span.appendChild(document.createTextNode(displayText));

     const parts = splitWithContext(normalizedValue, normalizedText, contextBefore, contextAfter);

      const frag = document.createDocumentFragment();
      if (parts[0]) frag.appendChild(document.createTextNode(parts[0]));
      frag.appendChild(span);
      if (parts[1]) frag.appendChild(document.createTextNode(parts[1]));

      parent.replaceChild(frag, node);
      break;
    }
  });

  return doc;
};
